<template>
    <div class="invoiceDetail">
        <div class="invoice-detail-item flex align-center">
            <div class="invoice-item-left">发票状态</div>
            <div :class="[invoiceData.status == 1 ? 'record-item-status1' : invoiceData.status == 0 ? 'record-item-status2' : invoiceData.status == 2 ? 'record-item-status3' : invoiceData.status == 3 ? 'record-item-status1' : '']">
                {{ invoiceData.status == 1 ? "已开票" : invoiceData.status == 0 ? "待开票" : invoiceData.status == 2 ? "开票失败" : invoiceData.status == 3 ? "补开发票" : "" }}
            </div>
            <van-icon v-if="invoiceData.status != 2" name="photo-o" @click="previewImg" color="#009AF3 " size="28px" style="margin-left: auto" />
        </div>
        <p class="invoice-item-title">收费方式</p>
        <div class="invoice-detail-item flex align-center">
            <div class="invoice-item-left">电子邮件</div>
            <div class="invoice-item-right">{{ invoiceData.email }}</div>
        </div>
        <div class="invoice-detail-item flex align-center">
            <div class="invoice-item-left">短信</div>
            <div class="invoice-item-right">{{ invoiceData.phoneNo }}</div>
        </div>
        <!-- <div class="invoice-detail-item flex align-center">
            <div class="invoice-item-left">微信卡包</div>
            <div class="invoice-item-right">{{ invoiceData.wechat == 1 ? "未推送" : invoiceData.wechat == 2 ? "已推送" : "" }}</div>
        </div>
        <div class="invoice-detail-item flex align-center">
            <div class="invoice-item-left">支付宝发票管家</div>
            <div class="invoice-item-right">{{ invoiceData.aliPay == 1 ? "未推送" : invoiceData.aliPay == 2 ? "已推送" : "" }}</div>
        </div> -->
        <p class="invoice-item-title">收票方式</p>
        <div class="invoice-detail-item flex align-center">
            <div class="invoice-item-left">发票抬头</div>
            <div class="invoice-item-right">{{ invoiceData.title }}</div>
        </div>
        <div class="invoice-detail-item flex align-center">
            <div class="invoice-item-left">税号</div>
            <div class="invoice-item-right">{{ invoiceData.taxesno }}</div>
        </div>
        <div class="invoice-detail-item flex align-center">
            <div class="invoice-item-left">发票内容</div>
            <div class="invoice-item-right">{{ invoiceData.content }}</div>
        </div>
        <div class="invoice-detail-item flex align-center">
            <div class="invoice-item-left">发票金额</div>
            <div class="invoice-item-right text-price">{{ invoiceData.money }}</div>
        </div>
        <div class="invoice-detail-item flex align-center">
            <div class="invoice-item-left">申请时间</div>
            <div class="invoice-item-right text-price">{{ invoiceData.createTime }}</div>
        </div>
        <div class="reInvoice-btn" v-if="invoiceData.status == 2">
            <van-button v-debounce="reInvoice" class="comfirm-btn">重新开票</van-button>
        </div>
        <van-image-preview v-model="showPreviewImg" :images="images" />
    </div>
</template>

<script>
import { restartElectronicInvoice } from "@/api/index";
export default {
    name: "InvoiceDetail",
    data() {
        return {
            invoiceData: {},
            showPreviewImg: false,
            images: [],
        };
    },
    mounted() {
        this.invoiceData = this.$route.params;
    },
    methods: {
        //重新开票
        reInvoice() {
            let obj = {
                fpqqlsh: this.invoiceData.invoiceCode,
            };
            restartElectronicInvoice(obj).then((res) => {
                if (res.data.status == 1) {
                    this.$router.push({ name: "InvoiceSuccess", params: obj });
                }
            });
        },
        previewImg() {
            this.images = [this.invoiceData.invoiceUrl];
            this.showPreviewImg = true;
        },
    },
};
</script>

<style lang="less" scoped>
@import "~@/assets/style/base.less";
@import "~@/assets/style/color.less";

.comfirm-btn {
    color: #fff;
    background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
}
.invoiceDetail {
    .invoice-detail-item {
        background-color: #fff;
        width: 750px;
        padding: 34px 30px;
        border-bottom: @comboder;
        .invoice-item-left {
            width: 138px;
            white-space: wrap;
            font-size: 28px;
            color: #333333;
        }
        .invoice-item-right {
            font-size: 28px;
            color: #666666;
        }
        .record-item-status1 {
            font-size: 28px;
            color: @main-color;
        }
        .record-item-status2 {
            font-size: 28px;
            color: #f76a2d;
        }
        .record-item-status3 {
            font-size: 28px;
            color: #f72d2d;
        }
    }
    .invoice-item-title {
        font-size: 26px;
        color: #33333380;
        padding: 20px 30px;
    }
    .reInvoice-btn {
        position: fixed;
        bottom: 0;
        background-color: #fff;
        padding: 30px;
    }
}
</style>
